<template>
  <div class="housekey">
    <RemoteAutoComplete
      v-model.trim="location"
      :label="locationLabel"
      :name="plzName"
      :data-name2="ortName"
      :placeholder="locationPlaceholder"
      pattern="[0-9]{4}\s*[^0-9 ]{2,}"
      :callback="searchLocation"
      :debounce="300"
      :required="required"
      :min-length="2"
      :max-results="100"
      :data-error="requiredMessageLocation"
      @isSuggestionOpen="val => handleBlur(location, locations, val)"
    />
    <div class="housekey-container san-25-75-formelement">
      <div class="housekey-street three-quarter right-spacer">
        <RemoteAutoComplete
          v-model.trim="street"
          :label="streetLabel"
          :placeholder="streetPlaceholder"
          :name="streetName"
          :required="required"
          :callback="searchStreet"
          :debounce="300"
          :min-length="2"
          :data-error="requiredMessageStreet"
          :max-results="100"
          @isSuggestionOpen="val => handleBlur(street, streets, val)"
        />
      </div>
      <div class="housekey-number one-quarter">
        <RemoteAutoComplete
          v-model.trim="houseNumber"
          :label="houseNumberLabel"
          :placeholder="houseNumberPlaceholder"
          :name="houseNumberName"
          :data-name2="houseNumberAddonName"
          :required="required"
          :callback="searchHouseNumber"
          :data-error="requiredMessageHouseNumber"
          :debounce="300"
          :min-length="1"
          :max-results="100"
          @isSuggestionOpen="val => handleBlur(houseNumber, houseNumbers, val)"
        />
      </div>
    </div>
    <sanitas-tooltip
      v-if="tooltipContent"
      :content="tooltipContent"
      :label="tooltipLabel"
      tabindex="-1"
    />
  </div>
</template>

<script>
import { client } from '@/helpers/http'

import RemoteAutoComplete from './RemoteAutoComplete'
import SanitasTooltip from './SanitasTooltip'

export default {
  name: 'HouseKeyModule',
  components: { SanitasTooltip, RemoteAutoComplete },

  props: {
    locationLabel: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      required: true,
    },
    streetLabel: {
      type: String,
      default: '',
    },
    houseNumberLabel: {
      type: String,
      default: '',
    },
    plzName: {
      type: String,
      required: true,
    },
    ortName: {
      type: String,
      required: true,
    },
    streetName: {
      type: String,
      required: true,
    },
    houseNumberName: {
      type: String,
      required: true,
    },
    houseNumberAddonName: {
      type: String,
      required: true,
    },
    requiredMessageLocation: {
      type: String,
      default: '',
    },
    requiredMessageStreet: {
      type: String,
      default: '',
    },
    requiredMessageHouseNumber: {
      type: String,
      default: '',
    },
    requiredMessageGeneral: {
      type: String,
      default: '',
    },
    locationPlaceholder: {
      type: String,
      default: '',
    },
    streetPlaceholder: {
      type: String,
      default: '',
    },
    houseNumberPlaceholder: {
      type: String,
      default: '',
    },
    checkboxForceTitle: {
      type: String,
      default: '',
    },
    checkboxForceError: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    isMulti: {
      type: Boolean,
      default: true,
    },
    isHouseKey: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Object,
      default: () => {},
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    tooltipLabel: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    location: '',
    street: '',
    houseNumber: '',
    locations: [],
    streets: [],
    houseNumbers: [],
  }),
  methods: {
    async searchLocation(term) {
      return client('api')
        .get('masterdata/location-search', {
          q: encodeURI(term),
        })
        .then(locations => {
          let locationsForOptions = locations.map(l => {
            const location = Object.assign({}, l, {
              zipCodeAddOn: l.zipCodeAddOn || l.zipCodeAddon,
            })
            const name = `${location.displayName}, ${location.canton}`
            return { name, value: name, zipCode: location.zipCode }
          })
          this.locations = locationsForOptions.map(l => {
            return l.name
          })
          return locationsForOptions
        })
    },
    searchStreet(term) {
      const { location } = this
      const zipCode = location.split(' ')[0]
      return client('api')
        .get('masterdata/streets', {
          street: encodeURI(term),
          zipcode: zipCode,
        })
        .then(streets => {
          this.streets = streets
          return streets.map(name => {
            return { name, value: name }
          })
        })
    },
    searchHouseNumber(term) {
      const { location, street } = this
      const zipcode = location.split(' ')[0]
      return client('api')
        .get('masterdata/housenumbers', {
          street,
          zipcode,
          housenumber: encodeURI(term),
        })
        .then(houseNumbers => {
          this.houseNumbers = houseNumbers
          return houseNumbers.map(name => {
            return { name, value: name }
          })
        })
    },
    handleBlur(value, array, suggestionOpen) {
      if (!suggestionOpen) {
        const {
          requiredMessageGeneral,
          checkboxForceTitle,
          checkboxForceError,
        } = this
        window.dispatchEvent(
          new CustomEvent('house-key-error', {
            detail: {
              error: requiredMessageGeneral,
              name: checkboxForceTitle,
              checkBoxError: checkboxForceError,
              show: !array.includes(value),
            },
          }),
        )
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.housekey-container {
  display: flex;
  justify-content: space-between;
}
</style>
